export enum LANGUAGE_CODES {
  EN = "en",
  TR = "tr",
}

export const ROUTES: Record<string, { [lang in LANGUAGE_CODES]: string }> = {
  home: {
    [LANGUAGE_CODES.TR]: "",
    [LANGUAGE_CODES.EN]: "",
  },
  // ---------------------------------------------------About
  about: {
    [LANGUAGE_CODES.TR]: "hakkimizda",
    [LANGUAGE_CODES.EN]: "about",
  },
  securitasRiskManagement: {
    [LANGUAGE_CODES.TR]: `securitas-kalite`,
    [LANGUAGE_CODES.EN]: `securitas-risk-management`,
  },
  securitasGroup: {
    [LANGUAGE_CODES.TR]: `securitas-grup`,
    [LANGUAGE_CODES.EN]: `securitas-group`,
  },
  ourValues: {
    [LANGUAGE_CODES.TR]: `degerlerimiz`,
    [LANGUAGE_CODES.EN]: `our-values`,
  },
  // ---------------------------------------------------About
  // ---------------------------------------------------Activities
  activities: {
    [LANGUAGE_CODES.TR]: "hizmetlerimiz",
    [LANGUAGE_CODES.EN]: "ourservices",
  },
  fecf: {
    [LANGUAGE_CODES.TR]: "fce",
    [LANGUAGE_CODES.EN]: "fce",
  },
  continuousSecurityConsulting: {
    [LANGUAGE_CODES.TR]: "multi-rol-guvenlik-gorevlisi",
    [LANGUAGE_CODES.EN]: "continuous-security-consulting",
  },
  drill: {
    [LANGUAGE_CODES.TR]: "drill",
    [LANGUAGE_CODES.EN]: "drill",
  },
  inspection: {
    [LANGUAGE_CODES.TR]: "denetim",
    [LANGUAGE_CODES.EN]: "inspection",
  },
  procedure: {
    [LANGUAGE_CODES.TR]: "prosedur",
    [LANGUAGE_CODES.EN]: "procedure",
  },
  simulation: {
    [LANGUAGE_CODES.TR]: "simulasyon",
    [LANGUAGE_CODES.EN]: "simulation",
  },
  remoteInspectionService: {
    [LANGUAGE_CODES.TR]: "itfaiye-hizmeti",
    [LANGUAGE_CODES.EN]: "remote-inspection-service",
  },
  securityEngineering: {
    [LANGUAGE_CODES.TR]: "guvenlik-muhendisligi",
    [LANGUAGE_CODES.EN]: "security-engineering",
  },
  continuousConsulting: {
    [LANGUAGE_CODES.TR]: "surekli-danismanlik",
    [LANGUAGE_CODES.EN]: "continuous-consulting",
  },
  securityAnalysis: {
    [LANGUAGE_CODES.TR]: "guvenlik-analizi",
    [LANGUAGE_CODES.EN]: "security-analysis",
  },
  systemDesign: {
    [LANGUAGE_CODES.TR]: "sistem-dizayni",
    [LANGUAGE_CODES.EN]: "system-design",
  },
  // ---------------------------------------------------Activities
  blog: {
    [LANGUAGE_CODES.TR]: "blog",
    [LANGUAGE_CODES.EN]: "blog",
  },
  // ---------------------------------------------------Sustainability
  educations: {
    [LANGUAGE_CODES.TR]: "egitimlerimiz",
    [LANGUAGE_CODES.EN]: "educations",
  },
  securityView: {
    [LANGUAGE_CODES.TR]: "guvenlik-yaklasimi",
    [LANGUAGE_CODES.EN]: "security-view",
  },
  corporateRiskAnalysis: {
    [LANGUAGE_CODES.TR]: "kurumsal-risk-analizi",
    [LANGUAGE_CODES.EN]: "corporate-risk-analysis",
  },
  fiveBasicElements: {
    [LANGUAGE_CODES.TR]: "yanginda-davranis-sekilleri",
    [LANGUAGE_CODES.EN]: "services-fire-behavior-patterns",
  },
  projectDesign: {
    [LANGUAGE_CODES.TR]: "yanginda-ilk-5-dakika",
    [LANGUAGE_CODES.EN]: "project-design",
  },
  technologicalApproach: {
    [LANGUAGE_CODES.TR]: "teknoloji-yaklasimi",
    [LANGUAGE_CODES.EN]: "technological-approach",
  },
  beginningTheProject: {
    [LANGUAGE_CODES.TR]: "ileri-seviye-atesli-temel-itfaiye-egitimi",
    [LANGUAGE_CODES.EN]: "beginning-the-project",
  },
  references: {
    [LANGUAGE_CODES.TR]: "teorik-ve-uygulamali-yangin-egitimi",
    [LANGUAGE_CODES.EN]: "references",
  },
  // ---------------------------------------------------Sustainability
  servicesWatchman: {
    [LANGUAGE_CODES.TR]: "gozlem-hizmeti",
    [LANGUAGE_CODES.EN]: "services-watchman",
  },

  contact: {
    [LANGUAGE_CODES.TR]: "iletisim",
    [LANGUAGE_CODES.EN]: "contact",
  },
};
